export default __webpack_public_path__ + "static/media/newsletterNotch.f9e0d64f.svg";